// ADDED
import React, { useState } from "react";
import OvertimeRequestModule from "../../components/modules/OvertimeRequest/OvertimeRequestModule";
// import OvertimeRequestHistory from "../../components/modules/OvertimeRequest/components/OvertimeRequestHistory";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { useOvertimeRequest } from "../../hooks/useOvertimeRequest";
import { LoadingSpinner } from "../../../common/Loading";
import OvertimeRequestHistory from "../../components/modules/OvertimeRequest/components/OvertimeRequestHistory";

function OvertimeRequestPage({ user, userAccess, isHideSideMenu }) {
  const [showHistoryModal, setShowHistoryModal] = useState(false);

  const {
    requests, loading, maxHours, formData,
    handleInputChange, handleFileChange, submitRequest,
    showMessage, message, isSuccess
  } = useOvertimeRequest(user);

  return (
    <>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="MainteInfo shadow-xl bg-white rounded-lg">

            {/* Header */}
            <div className="mainteHeader p-4 border-b flex justify-between items-center">
              <div>
                <div className='sub-title row text-sm'>
                  <span className="text-gray-400">{"Transaction "} &gt; </span>
                  <span className="border-b border-black">{"Overtime"}</span>
                </div>
                <h3 className="text-xl font-bold mt-2">Overtime Request</h3>
              </div>

              <button
                onClick={() => setShowHistoryModal(true)}
                className="flex items-center bg-cyan-500 hover:bg-cyan-600 text-white px-4 py-2 rounded-md border-none cursor-pointer transition-colors shadow-sm font-medium"
              >
                <RemoveRedEyeIcon fontSize="small" className="mr-2" />
                VIEW HISTORY
              </button>
            </div>

            <OvertimeRequestModule
              user={user}
              userAccess={userAccess}
              formData={formData}
              maxHours={maxHours}
              handleInputChange={handleInputChange}
              handleFileChange={handleFileChange}
              submitRequest={submitRequest}
              showMessage={showMessage}
              message={message}
              isSuccess={isSuccess}
              loading={loading}
            />
          </div>
        </div>
      </div>

      <OvertimeRequestHistory
        isOpen={showHistoryModal}
        onClose={() => setShowHistoryModal(false)}
        data={requests || []}
      />

      <LoadingSpinner loading={loading} />
    </>
  );
}

export default OvertimeRequestPage;